import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useRequest } from '../../../hooks/UseRequest'
import { selectAuth } from '../../../redux/authSlice'

export function useChirpReportData(id) {
  const auth = useSelector(selectAuth)
  const requests = useRequest()
  const [responseData, setResponseData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [bankChange, setBankChange] = useState(null)
  const [managerApproval, setManagerApproval] = useState(null)
  const [customer, setCustomer] = useState(null)

  useEffect(() => {
    if (!auth.fromPageChange) { return }
    if (auth.accessToken) {
      if (!id) {
        setErrorMessage('Missing id parameter')
        setIsLoading(false)
        return
      }

      setIsLoading(true)
      setErrorMessage('')
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/bank_transaction_provider_call/${id}/chirp_report`)
      requests.get()
        .then((res) => {
          const apiData = res?.data?.data
          setBankChange(apiData?.bank_change || null)
          setManagerApproval(apiData?.manager_approval || null)
          setCustomer(apiData?.customer || null)
          if (apiData?.report) {
            setResponseData(apiData.report)
          } else {
            setResponseData(null)
            setErrorMessage('Response data not available')
          }
        })
        .catch(() => {
          setResponseData(null)
          setErrorMessage('Response data not available')
        })
        .finally(() => setIsLoading(false))
    }
    // auth.fromPageChange is a mount-time gate (docs/STATE_MANAGEMENT.md), not a re-fetch trigger,
    // and `requests` methods are recreated on every render by useRequest(), so neither belongs here.
  }, [id, auth.accessToken])

  return {
    responseData,
    isLoading,
    errorMessage,
    bankChange,
    managerApproval,
    setManagerApproval,
    customer,
  }
}
